import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import { useGetCommercialistaIdQuery } from "../../api/admin/gestisciCommercialistiApi";
import FormOperator from "../../common/SchedaOperatore/FormOperator";
import AssociateTableUser from "./AssociateTableUser";
import { useTranslation } from "react-i18next";
import CoreBack from "../../../app/core/components/CoreBack/CoreBack";

const SchedaCommercialista = () => {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();

  const { data, isLoading, isFetching } = useGetCommercialistaIdQuery(
    params.id
  );

  const isValidationOperator = data && data.Data;

  if (isLoading && !isValidationOperator) {
    return <CoreSpinner />;
  }

  return (
    <div className="flex-row">
      <div className="flex items-center w-full ">
        <CoreBack />
        <div className="w-11/12">
          <h2>{`${t("Operator")} ${data?.Data?.name}`}</h2>
        </div>
      </div>

      <div className="flex space-x-8">
        <div className="w-6/12">
          <FormOperator operatorData={data} />
        </div>

        <div className="w-6/12 ">
          <AssociateTableUser
            userData={data?.Data?.associatedUsers}
            adminId={params.id}
          />
        </div>
      </div>
    </div>
  );
};

export default SchedaCommercialista;
